import { render, staticRenderFns } from "./VoterViewDialog.vue?vue&type=template&id=c6f2a936&scoped=true"
import script from "./VoterViewDialog.vue?vue&type=script&lang=js"
export * from "./VoterViewDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6f2a936",
  null
  
)

export default component.exports